'use client';

import React from 'react';
import { NumerologyNumberDetail } from '@/lib/api/client';
import { Sparkles, Star } from 'lucide-react';

interface NumerologyCardProps {
  label: string;
  detail: NumerologyNumberDetail;
}

export function NumerologyResultCard({ label, detail }: NumerologyCardProps) {
  return (
    <div className={`bg-[rgba(5,10,36,0.92)] border ${detail.isMasterNumber ? 'border-[#ffd36b]/50 shadow-[0_0_25px_rgba(255,211,107,0.15)]' : 'border-white/16'} rounded-3xl p-6 backdrop-blur-xl shadow-xl relative overflow-hidden transition-all`}>
      {detail.isMasterNumber && (
        <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1 rounded-full bg-[#ffd36b]/15 border border-[#ffd36b]/40 text-[#ffd36b] text-xs font-bold uppercase tracking-wider shadow-md">
          <Star className="w-3.5 h-3.5 fill-[#ffd36b]" />
          <span>Master Number</span>
        </div>
      )}

      <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-left">
        <div className={`w-20 h-20 rounded-2xl flex items-center justify-center text-3xl font-heading font-bold shrink-0 ${
          detail.isMasterNumber
            ? 'bg-[#ffd36b]/15 text-[#ffd36b] border-2 border-[#ffd36b]/50 shadow-lg shadow-[#ffd36b]/20'
            : 'bg-white/[0.06] text-[#b9c6ff] border border-white/20'
        }`}>
          {detail.number}
        </div>

        <div className="space-y-1.5 flex-1">
          <div className="text-xs font-semibold text-[#5ab4ff] uppercase tracking-wider">
            {label}
          </div>
          <h3 className="text-xl font-heading font-bold text-white">
            {detail.title}
          </h3>
          <p className="text-[rgba(220,236,255,0.85)] text-sm leading-relaxed pt-1">
            {detail.meaning}
          </p>
        </div>
      </div>
    </div>
  );
}
